import React, { Component } from 'react';
import axios from "axios";
//import logoreg from "../abc.png";
import Path from "./config";
export class PaymentSuccess extends Component {
    constructor(props) {
        super(props)
        this.state = {
            payment_id: ""
        }
    }

    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            phoneId: localStorage.getItem("phoneId")
        })

        let webid = new URLSearchParams(this.props.location.search);
        let webi = webid.get("payment_id");

        //  console.log(webi)
        if (!localStorage.getItem("userId") && webi === "") {
            //alert("please register your number and make payment")
            this.props.history.push(`/`);
        }


    }
    NextForm = () => {

        let webid = new URLSearchParams(this.props.location.search);
        let webidnew = webid.get("payment_id");

        // console.log("webidnew", webidnew)
        // console.log("userId", this.state.userId)

        if (this.state.userId !== "" && webidnew !== "") {
            alert("yes")
            let typee = "Payment";
            let feeType = "nondani";
            // let amt = "100";
            let amt = "50";
            let tempStr = "sbg_payment_amount=" + amt +
                "&sbg_id=" + localStorage.getItem("userId") +
                "&type=" + typee +
                "&feeType=" + feeType;


            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    //  console.log("response.data", response.data)
                    if (response.data.status === "updated") {

                        this.props.history.push(`./FormProfile`);

                    } else {
                        alert("Payment not Received");
                    }



                }.bind(this))

            //this.props.history.push('./FormProfileNew');
        }
        else {
            alert("not")
            //this.props.history.push('/');
        }
    }

    render() {
        //console.log ("userId",this.state.userId );
        //console.log ("paymenId",this.state.payment_id );

        return (
            <>
                <div className="container-fluid text-success text-center m-2 font-weight-normal">
                    Payment Success..
                </div>
                <div className="container-fluid">
                    {/* <span className="align-middle d-flex justify-content-center">
            <img src={logoreg} alt="logo" style={{width:"100px"}}></img></span> */}
                    <div className="row justify-content-md-center my-2 ">
                        <div className="col-md-8 border  border-5 p-3 mb-2 ">
                            <h4 className="text-primary">फॉर्म भरण्याची guideline  </h4>
                            <p>कृपया मराठीत फॉर्म भरतांना त्या शब्दाचे मराठी उच्चारानुसार स्पेलिंग बनवल्यास आपले मराठीत शब्द बरोबर
                                येतात त्यानंतर योग्य शब्द सिलेक्ट करावा. याची काळजी घ्यावी.</p>

                            <p> उदा.<br />
                                फैजपुर असे टाईप करण्यासाठी faijpur असे स्पेलिंग  टाईप करावे लागते <br />
                                काही अजून उदाहरण सोबत दिले आहे समजून घ्यावे <br />
                                एम :- em<br />
                                एन :- en<br />
                                भालोद :- bhaalod<br />
                                मोताळा :- motalaa<br />
                                जळगाव :- jalgav<br />
                                कॉलनी :- kolani किंवा colani <br />
                                सांभाळणारी :- saambhaalanaari <br />
                                अशा प्रकारे उच्चार नुसार स्पेलिंग बनवावे लागते.</p>

                            <p>
                                काही गडबड झाल्यास आमच्याकडुन स्वताः हुन हातोहात माहिती पूर्ण करून एकाच वेळेस सर्व चुका दुरुस्त करून घ्याव्या.
                                <br />

                                ज्यांना फॉर्म भरायला कुठेही अडचण आली तर लगेच ऑफिस कळवावे त्यापुढील फॉर्म गरज पडल्यास आम्ही भरून देऊ.<br />
                                त्यासाठी आम्हाला आमच्या व्हाट्स अँप वर आपला फोटो, बायो डेटा चा फोटो, ओळखपत्र चा फोटो आणि फी भरल्याचा
                                स्क्रीन शॉट पाठवावा.<br />आणि एक कॉल करून कळवावे.</p>

                        </div>
                        <div className="col-md-12 text-center">

                            <button class="btn btn-primary" type="button" onClick={() => this.NextForm()}>Click Here To Complete Your Form</button>

                        </div>
                    </div>

                </div>
            </>
        )
    }
}

export default PaymentSuccess
